import { apiClient } from '@/to-fsd/shared/api';

export const merchantsService = {
  /**
   * Метод получения информации о приложение
   *
   * @return {Promise}
   * @throws {Error}
   */
  getApp() {
    return apiClient.get('/merchant/core/v2/app');
  },

  // +
  getMerchantRelations(params) {
    return apiClient.get('/merchant/merchant/merchants/get-with-relations', { params });
  },

  // +
  getMerchantEmployees(query) {
    return apiClient.get(`/merchant/merchant/merchants/users`, { params: query });
  },
};
